module.exports = __webpack_public_path__ + "static/media/comments-no-data-MD.365c607c.jpg";